<template>
    <div>
        <b-navbar class="navbar navbar-fixed-top navbar-expand-lg" style="background-color: #5F5F5D">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <img src="@/assets/logo.png" width="40px" style="margin-left: 1em"/>
<!--                    <b style="padding-left: 1em">{{ header }}</b>-->
                </li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
                <b v-if="user">{{ welcome }} {{ user.name }}</b
                >&nbsp&nbsp
                <icon name="user" style="color: white"></icon>&nbsp&nbsp

                <!--<b-dropdown variant="link" size="lg" right no-caret>-->
                    <!--<template slot="button-content">-->
                        <!--<icon name="cog" style="color: white"></icon>-->
                        <!--<span class="sr-only">Settings</span>-->
                    <!--</template>-->
                    <!--<b-dropdown-item href="#" @click="logout">-->
                        <!--<span>Logout</span>-->
                    <!--</b-dropdown-item>-->
                <!--</b-dropdown>-->
            </form>
        </b-navbar>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "nav-header",
    props: {
        header: {
            default: "บริษัท สมบูรณ์ แพ็คเกจจิ้ง (888) จำกัด",
            type: String
        },
        welcome: {
            default: "ยินดีต้อนรับ คุณ",
            type: String
        }
    },

    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            }
        })
    },

    methods: {
        logout() {
            return this.$store
                .dispatch("Auth/logout")
                .then(() => this.$router.push("/login"));
        }
    }
};
</script>

<style lang="scss" scoped>
b {
    color: white;
}
</style>

<style lang="scss">
.b-dropdown {
    .btn {
        padding: 0 0 5px 0;
    }
}
</style>
